import Thumbnail from './thumbnail.element.js';

export default Thumbnail;

Thumbnail.define('wje-thumbnail', Thumbnail);
